



























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import CategoryManagementVue from "../components/FixedAsset/CategoryManagement.vue";
import AssistsVue from "../components/FixedAsset/Assists.vue";
import ReconciliationVue from "../components/FixedAsset/Reconciliation.vue";
import FixedAssetImportVue from "../components/FixedAsset/FixedAssetImport.vue";
import { mapGetters } from "vuex";
import { ElSelect } from "element-ui/types/select";
import AccountingSystem from "@/data/AccountingSystem";
import ThDropdownVue from "../components/ThDropdown.vue";
import version from "@/version";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        "category-management": CategoryManagementVue,
        "reconciliation-dialog": ReconciliationVue,
        "th-dropdown": ThDropdownVue,
        Assists: AssistsVue,
        "fixedAsset-import": FixedAssetImportVue,
    },
})
export default class FixedAsset extends Vue {
    @Prop({ type: Boolean })
    isDialog!: boolean;

    isClean: number = 0;
    dropName: string = "显示全部";

    // 下载
     downLoad() {
        let basic = "export/fixedassets"
        if(this.assetType === 1) basic = "export/fixedassets"
        if(this.assetType === 2) basic = "export/fixedassets2"
        if(this.assetType === 3) basic = "export/fixedassets3"

        let url = `${Vue.axios.defaults.baseURL}${basic}?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period}&endPeriod=${this.period}&token=${this.$store.state.account.token}&version=${version}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }  
    // 批量
    showCheck: boolean = false
    checkAll: boolean = false;
    changeAll(val: boolean) {
        this.assetsTable.forEach((v: any) => {
            if(v.id != null && v.canDel == 0 && this.$utils.canControl()) {
                v.checked = val;
            }
        });
    }
        // 监听全选
    @Watch("assetsTable", { deep: true })
    vouchersChange(val: Voucher.Voucher[]) {
        let all = true;
        for (let i = 0; i < val.length; i++) {
            if (!val[i].checked) {
                all = false;
                break;
            }
        }
        if (val.length === 0) all = false;
        this.checkAll = all;
    }
    batchList(val: string) {
        console.log(val);
        this.dropName = val;
        if (val === "显示全部") {
            this.isClean = 0;
            this.$nextTick(() => {
                this.fetchData();
            });
        } else if (val === "显示未清理") {
            this.isClean = 1;
            this.$nextTick(() => {
                console.log(this.isClean);
                this.fetchData();
            });
        } else this.isClean = 2;
        this.$nextTick(() => {
            this.fetchData();
        });
    }

    // 合计行数据
    assetsTotal: FixedAsset.FiexdFad[] = [];
    assetsTable: FixedAsset.FiexdFad[] = [];
    //改变时间
    period: string[] = []; // 日期
    changeDate(date: string[]) {
        this.period = date;
        this.getAssetClass();
        this.fetchData();
        this.clearNew();
    }
    assetClassList: FixedAsset.AssetClass[] = [];
    //新增固定资产的数据对象
    newAsset: FixedAsset.NewAsset = {
        id: null,
        accountBookId: this.$store.state.accountBook.id,
        assetsName: "",
        assetType: 1,
        method: "",
        fixedAssetsType: "",
        fixedAssetsTypeName: "",
        buyPeriod: "",
        originalValue: "",
        useMonth: "",
        oldValueRate: "",
        totalDepreciate: "",
        netValue: "",
        thisDepreciate: "",
        feeSubject: "",
        feeSubjectOBJ: null,
        depreciateSubject: "",
        depreciateSubjectOBJ: null,
        writePeriod: "",
        canAdd: 0,
        yearDepreciate: "",
        endRemainder: "",
        differenceValue: "",
        longNeedDepreciate: "",
        initRemainder: "",
        endTotal: "",
        number: "",
        remark:""
    };
    fixedAssetsList: any[] = [
        {
            text: "全部",
            id: 0
        }
    ];
    fixedAssetsType:any = this.fixedAssetsList[0]
    // 判断输入日期
    reg = /^((19\d{2})|(20[0-12][0-12]))+[1-12]$/;
    mounted() {
        //产品类别
        this.getAssetClass();
        // 科目
        this.getSubjects();
    }
    changeType: string = "''";
    hideList(val: any, obj: any, attr: string) {
        let components: any = this.$refs;
        if (!val) {
            obj[attr] = true;
            let prop = "";
            if (attr == "showAFee") {
                prop = "feeSubjectOBJ";
            } else {
                prop = "depreciateSubjectOBJ";
            }
            if (obj[prop].dimAccountType != null) {
                obj.showAssist = true;
                this.changeType = prop.split("OBJ").join("");
                obj.assistName = obj[prop].dimAccountType;
            }
        } else {
            this.assetsTable.forEach((v: FixedAsset.FiexdFad) => {
                v.showAssist = false;
            });
        }
    }
    // 点击科目
    clickSubject(e: any, asset: FixedAsset.FiexdFad, attr: string) {
        if (this.$utils.canControl()) {
            let td = e.target.parentNode;
            if (attr === "showAFee") asset.showAFee = false;
            else asset.showADep = false;
            this.$nextTick(() => {
                td.querySelector("input").focus();
            });
        }
    }
    // 删除这条固定资产
    deleteRow(id: number) {
        this.$msgbox({
            message: "确定要删除这条固定资产吗？",
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: true,
            cancelButtonText: "取消",
        })
            .then((action: any) => {
                if (action == "confirm") {
                    Vue.axios
                        .post(`fixedassets/` + id + `/delete`, {
                            endPeriod: this.period,
                        })
                        .then((res) => {
                            this.fetchData();
                        });
                }
            })
            .catch(() => {});
    }
    //修改固定资产科目
    editSubject(e: any, asset: FixedAsset.FiexdFad, attr: string) {
        let subject: Subject.Subject | null = null;
        for (let i = 0; i < this.subjectList.length; i++) {
            let v = this.subjectList[i];
            if (v.id === e) {
                subject = v;
                break;
            }
        }
        // @ts-ignore
        asset[attr] = subject;
        if (subject) {
            if (subject.dimAccountType != null) {
                asset.assistName = subject.dimAccountType;
                asset.assistNames = subject.dimAccountTypes;
                asset.showAssist = true;
            } else {
                this.verifyAsset(asset);
            }
        }
    }
    verifyAsset(asset: FixedAsset.FiexdFad) {
        asset.assistName = "";
        asset.showAssist = false;
        if (
            asset.assetsName != "" &&
            asset.buyPeriod != "" &&
            asset.originalValue != "" &&
            asset.useMonth != "" &&
            asset.oldValueRate != "" &&
            asset.totalDepreciate != null
        ) {
            asset.thisDepreciate = null;
            this.editOrAddAssets(asset, "修改科目");
        }
    }
    //获取列表数据
    fetchData() {
        Vue.axios
            .post(`fixedAssets/` + this.$store.state.accountBook.id + `/find`, {
                endPeriod: this.period,
                isClean: this.isClean,
                assetType: this.assetType,
                fixedAssetsType: this.fixedAssetsType.text === "全部"?"":this.fixedAssetsType.id
            })
            .then((res) => {
                res.data.fads.forEach((v: FixedAsset.FiexdFad) => {
                    v.feeSubject = Number(v.feeSubject);
                    v.depreciateSubject = Number(v.depreciateSubject);
                    v.showAFee = true;
                    v.showADep = true;
                    v.checked = false;
                });
                this.assetsTotal = []; //初始化合计
                this.assetsTotal.push(res.data.total);
                this.newAsset.canAdd = res.data.canAdd;
                this.assetsTable = res.data.fads;
            });
    }
    //获取产品类别
    async getAssetClass() {
        const res = await Vue.axios.post(
            `fixedAssetsCategory/${this.$store.state.accountBook.id}/findall?assetType=${this.assetType}`,
            {}
        );
        this.assetClassList = res.data;
        for (let i = 0; i < res.data.length; i++) {
            this.fixedAssetsList.push({ text: "", id: null });
            this.fixedAssetsList[i + 1].text = res.data[i].name;
            this.fixedAssetsList[i + 1].id = res.data[i].no;
        }
        console.log(this.fixedAssetsList)
    }
    //修改新增的资产类别
    changeAssetType(val: FixedAsset.AssetClass, asset: FixedAsset.AssetClass) {
        asset.method = val.method;
        // if (asset.name === "") asset.name = val.name;
        // if (asset.oldValueRate === "") asset.oldValueRate = val.oldValueRate;
        // else asset.oldValueRate = val.oldValueRate;
        // if (asset.useMonth === "") asset.useMonth = val.useMonth;
        asset.name = val.name;
        asset.oldValueRate = val.oldValueRate;
        asset.useMonth = val.useMonth;
    }
    //获取科目列表
    subjectList: Subject.Subject[] = [];
    getSubjects() {
        Vue.axios
            .post(`subjects/findleaf`, {
                accountBookId: this.$store.state.accountBook.id,
            })
            .then((res) => {
                this.subjectList = res.data;
            });
    }
    // 修改新增行的科目
    changeNewSub(val: string, attr: string) {
        if (attr === "depreciateSubject") this.newAsset.depreciateSubject = val;
        else this.newAsset.feeSubject = val;
    }
    // 点击行
    selectTheRow() {}
    //设置一个暂时存储原值的副本
    assetsCopy: string = ""; //数据列表copy
    setOldVal(e: any, val: string) {
        let allDrop = <NodeListOf<HTMLElement>>(
            document.querySelectorAll(".el-select-dropdown")
        );
        allDrop.forEach((element: HTMLElement) => {
            element.style.display = "none";
        });
        if (this.assetsCopy != val) {
            this.assetsCopy = val;
            e.target.select();
        }
    }
    //修改，新增凭证
    showVoucher: boolean = false; //显示凭证
    editOrAddAssets(
        asset: FixedAsset.NewAsset | FixedAsset.FiexdFad,
        mes: string,
        thisDepreciate?: boolean
    ) {
        asset.assetType = this.assetType;
        asset.endPeriod = this.period.toString();
        Vue.axios.post(`fixedassets/create`, asset).then((res) => {
            if (res.data.text != null) {
                this.$msgbox({
                    message: res.data.text,
                    title: "温馨提示",
                    confirmButtonText: "确定",
                    showCancelButton: false,
                });
            }
            if (res.data.voucher != null) {
                this.showVoucher = true;
                this.$nextTick(() => {
                    let newVoucher: any = this.$refs.voucher;
                    newVoucher.isDialog = true;
                    newVoucher.shouldGetInit = false;
                    newVoucher.isEdit = true;
                    newVoucher.isCheck = false;
                    newVoucher.showSaveAndAdd = false;
                    newVoucher.showAdd = false;
                    newVoucher.getSubjectList(null, () => {
                        newVoucher.packVoucher(res.data.voucher);
                    });
                });
            }

            this.$message.success(mes + "成功");

            if (mes === "新增") this.clearNew();
            this.fetchData();
        });
    }
    //修改固定资产
    editAssets(
        e: any,
        index: number,
        val: string,
        thisDepreciate: boolean,
        num: number,
        isModify?: number
    ) {
        if (isModify === undefined) this.assetsTable[index].isModifyTotal = 0;
        else this.assetsTable[index].isModifyTotal = isModify;
        let dateNum = Number(this.period);
        if (num == 2) {
            //必须输入正确的日期格式
            if (
                this.reg.test(this.assetsTable[index].buyPeriod) &&
                (e.relatedTarget === null ||
                    e.relatedTarget.className === "tdInput")
            ) {
                this.$msgbox({
                    message: "行" + (index + 1) + "购买日期有误，请修改一下。",
                    title: "温馨提示",
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    closeOnClickModal: false,
                    callback: (action: any) => {
                        if (action === "confirm") {
                            e.target.focus();
                        } else {
                            this.assetsTable[index].buyPeriod = this.assetsCopy;
                        }
                    },
                });
                throw "wrong";
            }
            if (
                Number(this.assetsTable[index].buyPeriod) > dateNum &&
                (e.relatedTarget === null ||
                    e.relatedTarget.className === "td-input")
            ) {
                this.$msgbox({
                    message: "购买日期应小于或等于当前期间",
                    title: "温馨提示",
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    callback: (action: any) => {
                        if (action === "confirm") {
                            e.target.focus();
                        }
                    },
                });
                throw "wrong";
            }
        }
        let odr = String(this.assetsTable[index].oldValueRate);
        // if (odr.indexOf(".") != -1) return;
        if (val != this.assetsCopy && val != "" && thisDepreciate == false) {
            this.assetsTable[index].thisDepreciate = null;
            this.editOrAddAssets(this.assetsTable[index], "修改");
            //修改月折旧额
        } else if (thisDepreciate && val != this.assetsCopy && val != "") {
            this.editOrAddAssets(this.assetsTable[index], "修改", true);
        }
    }
    //新增固定资产
    createAsset(e: any, buyPeriod = false) {
        let asset = this.newAsset;
        if (asset.buyPeriod === "" && buyPeriod) return;
        let dateNum = Number(this.period);
        let rowIndex = 1;
        rowIndex = this.assetsTable ? this.assetsTable.length + 1 : 1;
        //必须输入正确的日期格式
        if (Number(asset.buyPeriod) > dateNum && buyPeriod) {
            this.$msgbox({
                message: "购买日期应小于或等于当前期间",
                title: "温馨提示",
                confirmButtonText: "确定",
                showCancelButton: false,
                callback: (action: any) => {
                    if (action === "confirm") {
                        e.target.focus();
                    }
                },
            });
        }
        if (this.reg.test(asset.buyPeriod) && buyPeriod) {
            this.$msgbox({
                message: "行" + rowIndex + "购买日期有误，请修改一下。",
                title: "温馨提示",
                confirmButtonText: "确定",
                showCancelButton: false,
                closeOnClickModal: false,
                callback: (action: any, instance: any) => {
                    if (action === "confirm") {
                        e.target.focus();
                    }
                },
            });
        }
        // if (String(asset.oldValueRate).indexOf(".") != -1) {
        //     return;
        // }
        if (
            this.$utils.notNull([
                asset.assetsName,
                asset.buyPeriod,
                asset.originalValue,
                asset.useMonth,
            ])
        ) {
            asset.writePeriod = this.period.toString();
            let no = (<FixedAsset.AssetClass>asset.fixedAssetsType).no;
            asset.fixedAssetsType = no;
            this.editOrAddAssets(asset, "新增");
        }
    }
    //残值率设置
    oldValueOut(e: any) {
        if (e.target.value.indexOf(".") != -1) {
            // this.$msgbox({
            //     message: "残值率不得为小数，请修改!",
            //     title: "温馨提示",
            //     confirmButtonText: "确定",
            //     showCancelButton: false,
            //     closeOnClickModal: false,
            //     beforeClose: (action: any, instance: any, done: any) => {
            //         e.target.focus();
            //         done();
            //     },
            // });
        }
    }
    changeClass(e: any, index: number, asset: FixedAsset.FiexdFad) {
        asset.fixedAssetsType = e.toString();
        asset.thisDepreciate = null;
        this.editOrAddAssets(this.assetsTable[index], "修改");
    }
    changeMethod(e: any, index: number, asset: FixedAsset.FiexdFad) {
        asset.method = e;
        asset.thisDepreciate = null;
        this.editOrAddAssets(this.assetsTable[index], "修改");
    }
    // 清除新增内容
    clearNew() {
        this.newAsset.assetsName = "";
        this.newAsset.buyPeriod = "";
        this.newAsset.originalValue = "";
        this.newAsset.useMonth = "";
        this.newAsset.oldValueRate = "";
        this.newAsset.feeSubject = "";
        this.newAsset.depreciateSubject = "";
        this.newAsset.feeSubjectOBJ = null;
        this.newAsset.depreciateSubjectOBJ = null;
        this.newAsset.fixedAssetsType = "";
        this.newAsset.method = "";
        this.newAsset.yearDepreciate = "";
    }
    // 类别管理弹窗
    isAssetClass: boolean = false;
    showAssetClass() {
        this.isAssetClass = true;
    }
    closeAssetClass() {
        this.getAssetClass();
        this.isAssetClass = false;
    }
    // 对账弹窗
    isReconciliation: boolean = false;
    showReconciliation() {
        this.isReconciliation = true;
    }
    closeReconciliation() {
        this.isReconciliation = false;
    }
    // 确认辅助核算
    confirmAssist(val: Assist.Relation, asset: FixedAsset.FiexdFad) {
        let relation = this.changeType + "OBJ";
        // @ts-ignore
        asset[relation].relation = val;
        this.verifyAsset(asset);
    }
    // 关闭辅助核算
    closeAssist(asset: FixedAsset.FiexdFad, i: number) {
        this.assetsTable.splice(i, 1, asset);
        this.$set(asset, "showAssist", false);
    }
    closeVoucher() {
        this.changeDate(this.period);
    }
    // 批量删除
    delAll() {
        let arr:any = []
        for (let i = 0; i < this.assetsTable.length; i++) {
            if (this.assetsTable[i].checked)
                arr.push(this.assetsTable[i].id);
        }
        if(arr.length > 0) {
            this.$msgbox({
            message: "确定要删除所选中的固定资产吗？",
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: true,
            cancelButtonText: "取消",
        })
            .then((action: any) => {
                if (action == "confirm") {
                    Vue.axios
                        .post(`fixedassets/delete?ids=` + arr.join(","), {
                            endPeriod: this.period,
                        })
                        .then((res) => {
                            this.fetchData();
                        });
                    }
            })
            .catch(() => {});
        }else {
            this.$message({
                type: "warning",
                message: "请选择删除的内容",
            });
        }
    }
    // 导入凭证
    isImport() {
        this.showImport = true;
    }
    showImport: boolean = false;
    successImport() {
        this.fetchData();
        this.showImport = false;
    }

    // 键盘以聚焦
    focusComponent(e: KeyboardEvent, ref?: string, isEditTable?: boolean) {
        if (ref) {
            if (e.keyCode === 13) {
                if (isEditTable) {
                    const component = <ElSelect[]>this.$refs[ref];
                    component[0].focus();
                } else {
                    const component = <ElSelect>this.$refs[ref];
                    component.focus();
                }
            }
        } else {
            this.$utils.arrowPress(e);
        }
    }
    //清理此行固定资产
    cleanAsset(id: number) {
        Vue.axios
            .post(`fixedassets/` + id + `/clean`, {
                endPeriod: this.period,
                assetType: this.assetType,
            })
            .then((res) => {
                if (res.data.voucher != null) {
                    this.showVoucher = true;
                    this.$nextTick(() => {
                        let newVoucher: any = this.$refs.voucher;
                        newVoucher.isDialog = true;
                        newVoucher.shouldGetInit = false;
                        newVoucher.isEdit = true;
                        newVoucher.isCheck = false;
                        newVoucher.showSaveAndAdd = false;
                        newVoucher.showAdd = false;
                        newVoucher.getSubjectList(null, () => {
                            newVoucher.packVoucher(res.data.voucher);
                        });
                    });
                }
                this.fetchData();
            });
    }

    //还原此行固定资产
    reductionAsset(asset: FixedAsset.FiexdFad) {
        asset.assetType = this.assetType;
        Vue.axios.post(`fixedassets/reduction`, asset).then((res) => {
            this.fetchData();
        });
    }
    // 悬停删除按钮
    curIndex: number | null = null;
    showIcon(index: number) {
        this.curIndex = index;
    }
    offIcon() {
        this.curIndex = null;
    }
    // 滚动的计算
    scrollNum() {
        let sTop: any = document.querySelector("#FixedAsset .data-table .data-tbody");
        console.log(sTop.scrollTop)
        return sTop.scrollTop;
    }
    //修改凭证
    iconEdit(row: any) {
        if (row.voucherDto) {
            this.showVoucher = true;
            this.$nextTick(() => {
                let newVoucher: any = this.$refs.voucher;
                newVoucher.isDialog = true;
                newVoucher.shouldGetInit = false;
                newVoucher.isEdit = true;
                newVoucher.isCheck = false;
                newVoucher.showSaveAndAdd = false;
                newVoucher.showAdd = false;
                newVoucher.getSubjectList(null, () => {
                    newVoucher.packVoucher(row.voucherDto);
                });
            });
        }
    }

    // 类别切换
    get typeList() {
        if (
            this.$store.state.accountBook.accountingSystem ===
            AccountingSystem.rural
        ) {
            return [{ text: "固定资产", id: 1 }];
        } else {
            return [
                {
                    text: "固定资产",
                    id: 1,
                },
                {
                    text: "无形资产",
                    id: 2,
                },
                {
                    text: "长期待摊费用",
                    id: 3,
                },
            ];
        }
    }

    assetType = 1;
    async changeGenType(id: number) {
        this.assetType = id;
        await this.getAssetClass();
        this.fetchData();
    }

    // methodList: string[] = ["年限平均", "双倍余额递减", "不折旧"];
    get methodList() {
        switch (this.assetType) {
            case 1:
                return ["年限平均", "双倍余额递减", "不折旧"];
            case 2:
                return ["平均年限法", "不摊销"];
            case 3:
                return ["平均年限法"];
        }
    }

    closeImport() {
        this.showImport = false;
    }

    syncScroll() {
        const tbody = this.$el.querySelector(".edit-inner")!;
        const thead = this.$el.querySelector(".thead-wrap")!;
        const diff = tbody.scrollLeft;
        thead.scrollTo({
            left: diff
        });
        this.$el.querySelectorAll(".col-fixed")!.forEach(td => {
            (<HTMLElement>td).style.transform = `translateX(${diff}px)`;
        })
    }
}
